import React from "react";
import "./footer.css";

export default function Footer() {

    return (
        <footer>Coded by <a href="https://asivets-portfolio.netlify.app/about" target="_blank" rel="noreferrer">Anastasia.</a>Open sourced on <a href="https://github.com/siv921/new-react-weather-app.git" target="_blank" rel="noreferrer">Github</a> and hosted on <a href="https://asivets-react-city-weather-app.netlify.app/" target="_blank" rel="noreferrer">Netlify.</a> </footer>
    );
}